import { isAxiosError } from 'axios'

const collectMessages = (value: unknown): string[] => {
  if (typeof value === 'string') return [value]
  if (Array.isArray(value)) return value.flatMap(collectMessages)
  if (value && typeof value === 'object') {
    return Object.values(value).flatMap(collectMessages)
  }
  return []
}

export const getApiErrorMessage = (
  error: unknown,
  fallback = 'Une erreur est survenue lors de la sauvegarde.',
): string => {
  if (!isAxiosError(error)) return fallback
  return collectMessages(error.response?.data).join(' ') || fallback
}

/** Pourquoi une pièce n'a pas été envoyée, dit à l'assistante maternelle.
 *
 * Les refus du serveur ne sont pas des coupures réseau : les présenter comme tels faisait chercher le
 * problème au mauvais endroit (un 429 de limitation d'envois s'affichait « Vérifiez votre connexion »). */
export const uploadErrorMessage = (error: unknown): string => {
  const status = isAxiosError(error) ? error.response?.status : undefined
  switch (status) {
    case undefined:
      return "L'envoi n'a pas abouti. Vérifiez votre connexion puis choisissez à nouveau le fichier."
    case 413:
      return 'Fichier trop lourd (10 Mo max). Envoyez une photo ou un PDF plus léger.'
    case 415:
      return 'Format non accepté : envoyez un PDF, une photo JPG ou PNG.'
    case 429:
      return "Trop d'envois en peu de temps. Patientez quelques minutes puis choisissez à nouveau le fichier."
    default:
      return "L'envoi a été refusé. Rechargez la page puis choisissez à nouveau le fichier ; si cela se reproduit, contactez-nous."
  }
}
